import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getPas } from "../services/newActionServices";

export function usePaOptions({store, hfb, pcd}) {
  const [t] = useTranslation("global")
  const [paOptions, setPaOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (pcd && store && hfb) {
      setPaOptions([])
      setLoading(true)
      getPas({ store: store.id, hfb: hfb.id , PCD: pcd.id})
        .then((response) => {
          const newPasFormatted = response.map((pa)=>({label: `${pa.pa} ${pa.name}`, value: pa.pa}))
          newPasFormatted.push({
            value: "all",
            label: t("new-action.all-pa"),
          })
          setPaOptions(newPasFormatted)
        })
        .catch((error) => console.error("Error loading pa options:", error))
        .finally(()=>{
          setLoading(false)
        })
    }
  }, [pcd, store, hfb])

  return {
    loading,
    paOptions,
  }
}
